import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getAgenticWorkflowDetails } from '../../api/getAgenticWorkflowDetails';
import { queryKeys } from '../queryKeys';

export type UseGetAgenticWorkflowDetailsParams = {
    id: string;
    startDate: Date;
    endDate: Date;
    callStatus?: string;
    partyStage?: string;
    callDirection?: string;
    search?: string;
    perPage?: number;
    currentPage?: number;
    sortOrder?: 'asc' | 'desc';
    isRefetchEnabled?: boolean;
};

export const useGetAgenticWorkflowDetails = (props: UseGetAgenticWorkflowDetailsParams) => {
    const { data, isLoading, refetch, ...rest } = useQuery({
        queryKey: queryKeys.agenticWorkflowDetails(props),
        queryFn: () => getAgenticWorkflowDetails(props),
        enabled: !!(props.id && props.startDate && props.endDate),
        placeholderData: keepPreviousData,
        refetchInterval: (query) => {
            return props.isRefetchEnabled && query.state.data?.status === 'ACTIVE' ? 10000 : false;
        },
    });

    return {
        agenticWorkflowDetails: data,
        isLoadingAgenticWorkflowDetails: isLoading,
        refetchAgenticWorkflowDetails: refetch,
        ...rest,
    };
};
